export const BRAND = {
  PRIMARY: "#E26014",
  PRIMARY_LIGHT: "#FBE5D7",
  SECONDARY: "#F2F2F2",
};

export const DANGER = {
  SUPER_DARK: "#991b1b",
  DARK: "#a80724",
  MEDIUM: "#e23f5c",
  LIGHT: "#f16880",
  SUPER_LIGHT: "#ffe1e1",
};

export const WARNING = {
  DARK: "#8b5600",
  MEDIUM: "#b37208",
  LIGHT: "#ffac23",
  SUPER_LIGHT: "#fff0c9",
};

export const SUCCESS = {
  DARK: "#247800",
  MEDIUM: "#339a07",
  LIGHT: "#66cf39",
  SUPER_LIGHT: "#deffd1",
};

/* Light Mode Colors */

const LIGHT_GRAY = "#DDDDDD";
const LIGHT_ELEVATION = "#F7F8F9";
export const GRAYSCALE = {
  GRAY_SUPER_DARK: "#141211",
  GRAY_DARK: "#4D4D4D",
  GRAY_MEDIUM: "#7D7D7D",
  GRAY_MEDIUM_LIGHT: "#B1B1B1",
  GRAY_LIGHT: LIGHT_GRAY,
  GRAY_LIGHTEST: "#F0F1F2",
  GRAY_SUPER_LIGHT: LIGHT_ELEVATION,
  WHITE: "#FFFFFF",
  BORDER: LIGHT_GRAY,
  ELEVATION: LIGHT_ELEVATION,
};

export const SECONDARY = {
  SUPER_DARK: "#032026",
  DARK: "#084657",
  MEDIUM: "#2085BA",
  MEDIUM_LIGHT: "#44A8EB",
  LIGHT: "#70B9F6",
  LIGHTEST: "#9DCBFC",
  SUPER_LIGHT: "#C8DFFF",
  WHITE: "#F2F7FF",
};

/* Dark Mode Colors */

const DARK_LIGHT_GRAY = "#43464a";
export const DARK_GRAYSCALE = {
  GRAY_SUPER_DARK: "#111212",
  GRAY_DARK: "#1e1f21",
  GRAY_MEDIUM: "#232629",
  GRAY_MEDIUM_LIGHT: "#2b2d30",
  GRAY_LIGHT: DARK_LIGHT_GRAY,
  GRAY_LIGHTEST: "#63676b",
  GRAY_SUPER_LIGHT: "#8a8e91",
  WHITE: "#f7f9fb",
  BORDER: DARK_LIGHT_GRAY,
  ELEVATION: "rgba(174, 175, 177, 0.2)",
};

export const DARK_SECONDARY = {
  SECONDARY_SUPER_DARK: "#142736",
  SECONDARY_DARK: "#22445d",
  SECONDARY_MEDIUM: "#306082",
  SECONDARY_MEDIUM_LIGHT: "#3e7ca8",
  SECONDARY_LIGHT: "#5795c1",
  SECONDARY_LIGHTEST: "#a2c4dd",
  SECONDARY_SUPER_LIGHT: "#dae7f1",
};

/*
 * Custom Dark Colors
 * NOTE: Custom dark color primary & secondary palettes are not constant, they are generated from an input color.
 * see utils/color.ts
 */
